module.exports = __webpack_public_path__ + "static/media/IMG-10.9653ed30.jpg";